import { usePagination } from '@hooks';
import { PaginationMetadata } from '@modules/usersManagment/data/useGetAllUsersPaginated';

export interface TransactionLimit {
  id: number;
  transactionType: string;
  description: string;
}
interface pages extends PaginationMetadata {
  page: TransactionLimit[];
}
/**
 * Get limits by segment
 * @returns
 */
export const useGetLimitsBySegment = ({
  params,
  setURLparams,
  segmentId,
}: {
  params: object;
  setURLparams: () => void;
  segmentId: string;
}) => {
  const { data: paginatedData, ...props } = usePagination(
    segmentId && `/v3/partner/limits/${segmentId}`,
    {
      params,
      setURLparams,
      paramKeys: ['page', 'limit'],
    }
  );
  const data = paginatedData as pages | undefined;
  return { data, ...props };
};
